import DefaultHexImage from '../../../../assets/face-user.svg?react';
import { HexContainer } from '../hex-container/hex-container';
import './authentication-header.less';

interface AuthenticationHeaderProps {
  hexImage?: React.ReactNode;
  logoUrl?: React.ReactNode;
}

export const AuthenticationHeader = ({
  hexImage = <DefaultHexImage />,
  logoUrl,
}: AuthenticationHeaderProps) => {
  return (
    <div className="authn-layout-header">
      <span className="authn-layout-header-logo">{logoUrl}</span>
      <HexContainer className="authn-layout-header-hex" icon={hexImage} />
    </div>
  );
};
